import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { StarMark } from "@/components/Logo";

// Handles the return from Emergent-managed Google Auth: exchanges the
// #session_id fragment for an Owner JWT, then lands on the dashboard.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallback = () => {
  const { loginWithGoogleSession } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const match = window.location.hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    // Clear the fragment so the session_id is never kept in history.
    window.history.replaceState(null, "", window.location.pathname);
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    loginWithGoogleSession(sessionId)
      .then(() => navigate("/dashboard", { replace: true }))
      .catch((err) => {
        const msg = err.response?.data?.detail || "Google sign-in failed";
        toast.error(msg);
        navigate("/login", { replace: true });
      });
  }, [loginWithGoogleSession, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-ek-canvas" data-testid="google-auth-callback">
      <div className="flex flex-col items-center gap-3">
        <StarMark className="h-8 w-8 animate-pulse" />
        <p className="text-sm text-ek-ink/60">Completing secure sign-in…</p>
      </div>
    </div>
  );
};
